import api from "../index";

export const GetAllKycApi = (params) => api.get(`admin/getallkyc?${params}`);
export const GetSingleKycByIdApi = (kycId) => api.get(`admin/getsinglekyc/${kycId}`);
export const KycRequestAcceptRejectApi = (data) => api.post('admin/kycrejectedapproved', data);